import { render, staticRenderFns } from "./ProudctCopy.vue?vue&type=template&id=3246c498&scoped=true"
import script from "./ProudctCopy.vue?vue&type=script&lang=js"
export * from "./ProudctCopy.vue?vue&type=script&lang=js"
import style0 from "./ProudctCopy.vue?vue&type=style&index=0&id=3246c498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246c498",
  null
  
)

export default component.exports